module.exports = __webpack_public_path__ + "img/help.f03f571b.svg";